import { render, staticRenderFns } from "./form-list-dialog.vue?vue&type=template&id=2bdc7815&scoped=true&"
import script from "./form-list-dialog.vue?vue&type=script&lang=js&"
export * from "./form-list-dialog.vue?vue&type=script&lang=js&"
import style0 from "./form-list-dialog.vue?vue&type=style&index=0&id=2bdc7815&prod&lang=css&"
import style1 from "./form-list-dialog.vue?vue&type=style&index=1&id=2bdc7815&prod&rel=stylesheet%2Fscss&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdc7815",
  null
  
)

export default component.exports